import LoadingSpinner from "components/LoadingSpinner";
import { useGetVendorsQuery } from "features/vendor/vendorSlice"
import { PricingLookupStyle } from "./style";
import { useLazyGetActivityPricingByParametersQuery } from "../pricingSlice";
import { CircularProgress, Divider, IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import FormatService from "services/formatService";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { useState } from "react";
import { Fragment } from "react";
import { PricingLookupMenuItem } from "./PricingLookupMenuItem";
import { isAuthorized } from "components/Authorize/authorizeUtil";
import { permissionProfiles } from "components/Authorize/permissionProfiles";

export const PricingLookup = ({ onChange, activityItemId, bundleId, lotId, vehicleTypeId, vendorId, setVendorId, price, setNotSupported, clientId, disabled, materials, setCharge }) => {
    const classes = PricingLookupStyle()

    const [getPrices, { data: pricesResponse, error: pricesError, isLoading: isLoadingPrices, isFetching: isFetchingPrices }] = useLazyGetActivityPricingByParametersQuery();
    let { data: vendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();

    const vendorsLookup = vendors?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});

    const matchedTypeResponse = pricesResponse?.find(p => p.vehicleType == vehicleTypeId);
    const isFallback = matchedTypeResponse?.isFallback;
    const mechanicalsSlaMargin = matchedTypeResponse?.mechanicalsSlaMargin;
    const fallbackMessage = matchedTypeResponse?.fallbackMessage;

    let prices = matchedTypeResponse?.activityPrices?.map(activityPrice => {
        return {
            ...activityPrice,
            vendor: vendorsLookup?.[activityPrice?.vendorId]?.name,
            formattedPrice: FormatService.formatCurrency(activityPrice?.internalCost),
            formattedCharge: FormatService.formatCurrency(activityPrice?.charge),
        }
    });

    const hasFallbackMargin = isFallback && mechanicalsSlaMargin != null;
    const fallbackCharge = hasFallbackMargin && price > 0
        ? Math.round(price * (1 + mechanicalsSlaMargin / 100) * 100) / 100
        : null;

    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        if ((!!bundleId || !!activityItemId) && !!lotId && !!vehicleTypeId) {
            getPrices({
                activityItemId: bundleId ? null : activityItemId,
                bundleId: bundleId ? bundleId : null,
                lotId,
                vehicleTypeIds: Array.isArray(vehicleTypeId) ? vehicleTypeId : [vehicleTypeId],
                includeAllResults: true,
                clientId,
                materialsUsed: materials,
                includeCost: isAuthorized(permissionProfiles.ACTIVITY.EDIT_ACTIVITY_INTERNAL_FIELDS)
            });
        }
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // useEffect(() => {
    //     if (price === 0 || price === undefined || isNaN(price) || price === "") {
    //         let priceObject = prices?.find(p => p.vendorId == vendorId)
    //         onChange(priceObject?.internalCost);
    //         setCharge(priceObject?.charge);
    //     }
    // }, [vendorId]);


    return <>
        <LoadingSpinner loading={isLoadingVendors} />
        {
            ((!!activityItemId || !!bundleId) && !!lotId && !!vehicleTypeId) &&
            <>
                <Tooltip title='Lookup Price'>
                    <IconButton
                        onClick={handleClick}
                        disabled={disabled}
                    >
                        <LocalAtmIcon />
                    </IconButton>
                    {/* <Button
                        onClick={handleClick}
                        variant="contained"
                        color="primary"
                        className={classes.calculateButton}
                    >
                        Lookup
                    </Button> */}
                </Tooltip>

                <Menu
                    id="pricing-list"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        className: classes.pricingMenuPaper,
                    }}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    {!isFetchingPrices ? prices?.map((value, key) => (
                        <Fragment key={`${value?.vendorId}-${key}`}>
                            <MenuItem className={classes.pricingMenuItem} onClick={() => {
                                setNotSupported(value.notSupported);
                                onChange(value?.internalCost + (value?.materialsCost ?? 0));
                                setVendorId(value?.vendorId);
                                setCharge(value?.charge);
                                handleClose();
                            }}>
                                <PricingLookupMenuItem value={value} isBundle={!!bundleId} />
                            </MenuItem>
                            {key < prices.length - 1 ? <Divider /> : null}
                        </Fragment>
                    )) : <MenuItem disabled><CircularProgress size={'1em'} />Loading Prices...</MenuItem>}

                    {!isFetchingPrices && hasFallbackMargin && !price && (
                        <MenuItem disabled>
                            Enter an internal cost, then click Pricing Lookup again
                            <br />
                            to calculate the charge based on the Mechanicals SLA margin.
                        </MenuItem>
                    )}

                    {!isFetchingPrices && hasFallbackMargin && fallbackCharge != null && (
                        <MenuItem className={classes.pricingMenuItem} onClick={() => {
                            onChange(price);
                            setCharge(fallbackCharge);
                            setNotSupported(false);
                            handleClose();
                        }}>
                            <div className={classes.pricingDetails}>
                                <div className={classes.pricingLine}>
                                    <span className={classes.pricingLabel}>Based on</span>
                                    <span className={classes.pricingValue}>Mechanicals SLA</span>
                                </div>
                                <div className={classes.pricingLine}>
                                    <span className={classes.pricingLabel}>Margin</span>
                                    <span className={classes.pricingValue}>{mechanicalsSlaMargin}%</span>
                                </div>
                                <div className={classes.pricingLine}>
                                    <span className={classes.pricingLabel}>Charge</span>
                                    <span className={classes.pricingValue}>{FormatService.formatCurrency(fallbackCharge)}</span>
                                </div>
                            </div>
                        </MenuItem>
                    )}

                    {!isFetchingPrices && isFallback && !hasFallbackMargin && fallbackMessage && (
                        <MenuItem disabled>
                            {fallbackMessage}
                        </MenuItem>
                    )}

                    {!isFetchingPrices && isFallback && !hasFallbackMargin && !fallbackMessage && (
                        <MenuItem disabled>
                            No pricing available for this activity type.
                        </MenuItem>
                    )}

                    {!isFetchingPrices && !isFallback && (prices?.length == 0 || !prices) &&
                        <MenuItem disabled >
                            There are no prices in the price database
                            <br />
                            for this client, activity, lot and vehicle type
                        </MenuItem>
                    }
                </Menu>
            </>
        }
    </>

}